import React from 'react';

import { EDSModal } from '@gehc-eds-react/eds-modal';

import { EDSTextField } from '@gehc-eds-react/eds-text-field';


export const EditSourceModal = ({

    isOpen,

    editPrefix,

    setEditPrefix,

    editDisplayName,

    setEditDisplayName,

    isUpdatingSource,

    onClose,

    onSave

}) => {

    return (
        <EDSModal
            variant="standard"
            isOpen={isOpen}
            headerConfig={{ text: 'Edit Source', useCancelIcon: true }}
            footerConfig={{
                cancelButton: { label: 'Cancel', type: 'button', isDisabled: isUpdatingSource },
                acceptButton: { label: isUpdatingSource ? 'Updating...' : 'Update', type: 'button', isDisabled: isUpdatingSource }
            }}
            width="520px"
            onEDSModalButtonClickAccept={onSave}
            onEDSModalButtonClickCancel={onClose}
            onEDSModalClose={onClose}
            content={<div slot="main-content" style={{ display: 'grid', gap: '12px', padding: '20px 24px' }}>
                    <EDSTextField

                        name="edit-prefix"

                        label={{ width: '', position: 'top', text: 'Prefix' }}

                        value={editPrefix}

                        placeholder="Enter prefix"

                        isRequired={false}

                        width="100%"

                        type="text"

                        onEDSTextFieldChange={(e) => setEditPrefix(e.target.value)}

                    />
                    <EDSTextField

                        name="edit-display-name"

                        label={{ width: '', position: 'top', text: 'Display Name' }}

                        value={editDisplayName}

                        placeholder="Enter display name"

                        isRequired={false}

                        width="100%"

                        type="text"

                        onEDSTextFieldChange={(e) => setEditDisplayName(e.target.value)}

                    />
            </div>}
        />

    );

};

export const DeleteSourceModal = ({ isOpen, sourceToDelete, isDeletingSource, onClose, onConfirm }) => {

    if (!sourceToDelete) return null;

    return (
        <EDSModal
            variant="standard"
            isOpen={isOpen}
            headerConfig={{ text: 'Deboard source?', useCancelIcon: true }}
            footerConfig={{
                cancelButton: { label: 'Cancel', type: 'button', isDisabled: isDeletingSource },
                acceptButton: { label: isDeletingSource ? 'Deboarding...' : 'Deboard', type: 'button', isDisabled: isDeletingSource }
            }}
            width="420px"
            onEDSModalButtonClickAccept={onConfirm}
            onEDSModalButtonClickCancel={onClose}
            onEDSModalClose={onClose}
            content={<div slot="main-content" style={{ padding: '24px' }}>
                <p style={{ margin: '0 0 18px 0', color: '#555' }}>

                    Are you sure you want to deboard this source?
                </p>
                <p style={{ margin: '0 0 20px 0', color: '#333', fontWeight: 600 }}>

                    {sourceToDelete.account_id || '--'}
                </p>
            </div>}
        />

    );

};
